
/** * AUTO GENERATED CODE. DO NOT EDIT THIS FILE * TEMPLATE FILE IS LOCATED AT
/app/lib/templates/component-mapping.hbs */ import dynamic from 'next/dynamic'
import React from 'react'
/** * component to dynamic import map */ const componentMap = {
qbmds_accordion: dynamic(() => import('@qbmds/accordion')),
qbmds_accordion_item: dynamic(() => import('@qbmds/accordion-item')),
qbmds_article_tags: dynamic(() => import('@qbmds/article-tags')),
qbmds_badge: dynamic(() => import('@qbmds/badge')),
qbmds_brand_link: dynamic(() => import('@qbmds/brand-link')),
qbmds_button: dynamic(() => import('@qbmds/button')),
qbmds_card: dynamic(() => import('@qbmds/card')),
qbmds_card_item: dynamic(() => import('@qbmds/card-item')),
qbmds_checkbox: dynamic(() => import('@qbmds/checkbox')),
qbmds_codeblock: dynamic(() => import('@qbmds/codeblock')),
qbmds_container: dynamic(() => import('@qbmds/container')),
qbmds_container_item: dynamic(() => import('@qbmds/container-item')),
qbmds_cornerstone: dynamic(() => import('@qbmds/cornerstone')),
qbmds_ctablock: dynamic(() => import('@qbmds/ctablock')),
qbmds_disclaimer: dynamic(() => import('@qbmds/disclaimer')),
qbmds_disclaimer_content: dynamic(() => import('@qbmds/disclaimer-content')),
qbmds_disclaimer_group_heading: dynamic(() => import('@qbmds/disclaimer-group-heading')),
qbmds_dropdown: dynamic(() => import('@qbmds/dropdown')),
qbmds_dropdown_button: dynamic(() => import('@qbmds/dropdown-button')),
qbmds_dropdownbuttonitem: dynamic(() => import('@qbmds/dropdownbuttonitem')),
qbmds_dropdownlinkbuttonitem: dynamic(() => import('@qbmds/dropdownlinkbuttonitem')),
qbmds_experiment_comp: dynamic(() => import('@qbmds/experiment-comp')),
qbmds_feature: dynamic(() => import('@qbmds/feature')),
qbmds_featuredrawer: dynamic(() => import('@qbmds/featuredrawer')),
qbmds_footer: dynamic(() => import('@qbmds/footer')),
qbmds_footer_bottom: dynamic(() => import('@qbmds/footer-bottom')),
qbmds_footer_menu_section: dynamic(() => import('@qbmds/footer-menu-section')),
qbmds_footer_menus: dynamic(() => import('@qbmds/footer-menus')),
qbmds_global_nav: dynamic(() => import('@qbmds/global-nav')),
qbmds_heading: dynamic(() => import('@qbmds/heading')),
qbmds_hellobar: dynamic(() => import('@qbmds/hellobar')),
qbmds_hero: dynamic(() => import('@qbmds/hero')),
qbmds_home_page_hero_ca: dynamic(() => import('@qbmds/home-page-hero-ca')),
qbmds_horizontaltabs: dynamic(() => import('@qbmds/horizontaltabs')),
qbmds_image: dynamic(() => import('@qbmds/image')),
qbmds_leaderline: dynamic(() => import('@qbmds/leaderline')),
qbmds_link: dynamic(() => import('@qbmds/link')),
qbmds_mega_nav_menu_item: dynamic(() => import('@qbmds/mega-nav-menu-item')),
qbmds_mega_nav_section: dynamic(() => import('@qbmds/mega-nav-section')),
qbmds_menu_item: dynamic(() => import('@qbmds/menu-item')),
qbmds_menu_link: dynamic(() => import('@qbmds/menu-link')),
qbmds_modal: dynamic(() => import('@qbmds/modal')),
qbmds_nav_menu: dynamic(() => import('@qbmds/nav-menu')),
qbmds_on_page_nav: dynamic(() => import('@qbmds/on-page-nav')),
qbmds_onpagebanner: dynamic(() => import('@qbmds/onpagebanner')),
qbmds_pricing_hero_ca: dynamic(() => import('@qbmds/pricing-hero-ca')),
qbmds_pricingblock: dynamic(() => import('@qbmds/pricingblock')),
qbmds_pricingcard: dynamic(() => import('@qbmds/pricingcard')),
qbmds_pricingcarditem: dynamic(() => import('@qbmds/pricingcarditem')),
qbmds_pricingfeatureblock: dynamic(() => import('@qbmds/pricingfeatureblock')),
qbmds_pricingfeatureitem: dynamic(() => import('@qbmds/pricingfeatureitem')),
qbmds_pricingtoggle: dynamic(() => import('@qbmds/pricingtoggle')),
qbmds_products: dynamic(() => import('@qbmds/products')),
qbmds_promo: dynamic(() => import('@qbmds/promo')),
qbmds_radio: dynamic(() => import('@qbmds/radio')),
qbmds_responsivetext: dynamic(() => import('@qbmds/responsivetext')),
qbmds_secondary_nav: dynamic(() => import('@qbmds/secondary-nav')),
qbmds_separator: dynamic(() => import('@qbmds/separator')),
qbmds_spacer: dynamic(() => import('@qbmds/spacer')),
qbmds_switch: dynamic(() => import('@qbmds/switch')),
qbmds_tab: dynamic(() => import('@qbmds/tab')),
qbmds_tab_item: dynamic(() => import('@qbmds/tab-item')),
qbmds_tablist: dynamic(() => import('@qbmds/tablist')),
qbmds_tabpanel: dynamic(() => import('@qbmds/tabpanel')),
qbmds_tabs: dynamic(() => import('@qbmds/tabs')),
qbmds_testimonial: dynamic(() => import('@qbmds/testimonial')),
qbmds_testimonial_item: dynamic(() => import('@qbmds/testimonial-item')),
qbmds_text_grid: dynamic(() => import('@qbmds/text-grid')),
qbmds_text_grid_item: dynamic(() => import('@qbmds/text-grid-item')),
qbmds_textfield: dynamic(() => import('@qbmds/textfield')),
qbmds_tooltip: dynamic(() => import('@qbmds/tooltip')),
qbmds_user_profile_avatar: dynamic(() => import('@qbmds/user-profile-avatar')),
qbmds_verticalcarousel: dynamic(() => import('@qbmds/verticalcarousel')),
qbmds_verticalcarouselitem: dynamic(() => import('@qbmds/verticalcarouselitem')),
qbmds_video: dynamic(() => import('@qbmds/video')),
qbmds_videolink: dynamic(() => import('@qbmds/videolink')),
au_components_au_embeddable_sui: dynamic(() => import('@au-components/au-embeddable-sui')),
au_components_block_link: dynamic(() => import('@au-components/block-link')),
au_components_ged_layout_cell: dynamic(() => import('@au-components/ged-layout-cell')),
au_components_ged_section: dynamic(() => import('@au-components/ged-section')),
au_components_ultra_mega_nav: dynamic(() => import('@au-components/ultra-mega-nav')),
au_components_ultra_mega_nav_item: dynamic(() => import('@au-components/ultra-mega-nav-item')),
gwp_components_accordion: dynamic(() => import('@gwp-components/accordion')),
gwp_components_accordion_item: dynamic(() => import('@gwp-components/accordion-item')),
gwp_components_actionable: dynamic(() => import('@gwp-components/actionable')),
gwp_components_app_fabric_plugin: dynamic(() => import('@gwp-components/app-fabric-plugin')),
gwp_components_atf_btf_separator: dynamic(() => import('@gwp-components/atf-btf-separator')),
gwp_components_audio: dynamic(() => import('@gwp-components/audio')),
gwp_components_authentication: dynamic(() => import('@gwp-components/authentication')),
gwp_components_background: dynamic(() => import('@gwp-components/background')),
gwp_components_banner: dynamic(() => import('@gwp-components/banner')),
gwp_components_breadcrumbs: dynamic(() => import('@gwp-components/breadcrumbs')),
gwp_components_button: dynamic(() => import('@gwp-components/button')),
gwp_components_calculator: dynamic(() => import('@gwp-components/calculator')),
gwp_components_carousel: dynamic(() => import('@gwp-components/carousel')),
gwp_components_checkbox: dynamic(() => import('@gwp-components/checkbox')),
gwp_components_chip: dynamic(() => import('@gwp-components/chip')),
gwp_components_close_component_wrapper: dynamic(() => import('@gwp-components/close-component-wrapper')),
gwp_components_container: dynamic(() => import('@gwp-components/container')),
gwp_components_container_item: dynamic(() => import('@gwp-components/container-item')),
gwp_components_containment: dynamic(() => import('@gwp-components/containment')),
gwp_components_date_text: dynamic(() => import('@gwp-components/date-text')),
gwp_components_directorypage: dynamic(() => import('@gwp-components/directorypage')),
gwp_components_directorystore: dynamic(() => import('@gwp-components/directorystore')),
gwp_components_drop_down: dynamic(() => import('@gwp-components/drop-down')),
gwp_components_dynamic_links: dynamic(() => import('@gwp-components/dynamic-links')),
gwp_components_dynamic_list: dynamic(() => import('@gwp-components/dynamic-list')),
gwp_components_email_capture: dynamic(() => import('@gwp-components/email-capture')),
gwp_components_expandable: dynamic(() => import('@gwp-components/expandable')),
gwp_components_expert_profile: dynamic(() => import('@gwp-components/expert-profile')),
gwp_components_fieldset: dynamic(() => import('@gwp-components/fieldset')),
gwp_components_footer: dynamic(() => import('@gwp-components/footer')),
gwp_components_fragment: dynamic(() => import('@gwp-components/fragment')),
gwp_components_grid: dynamic(() => import('@gwp-components/grid')),
gwp_components_grid_item: dynamic(() => import('@gwp-components/grid-item')),
gwp_components_gwp_table: dynamic(() => import('@gwp-components/gwp-table')),
gwp_components_header: dynamic(() => import('@gwp-components/header')),
gwp_components_header_description: dynamic(() => import('@gwp-components/header-description')),
gwp_components_helix_banner: dynamic(() => import('@gwp-components/helix-banner')),
gwp_components_icon: dynamic(() => import('@gwp-components/icon')),
gwp_components_ids_badge: dynamic(() => import('@gwp-components/ids-badge')),
gwp_components_ids_button: dynamic(() => import('@gwp-components/ids-button')),
gwp_components_image: dynamic(() => import('@gwp-components/image')),
gwp_components_link: dynamic(() => import('@gwp-components/link')),
gwp_components_list: dynamic(() => import('@gwp-components/list')),
gwp_components_list_item: dynamic(() => import('@gwp-components/list-item')),
gwp_components_modal: dynamic(() => import('@gwp-components/modal')),
gwp_components_nav: dynamic(() => import('@gwp-components/nav')),
gwp_components_nav_item: dynamic(() => import('@gwp-components/nav-item')),
gwp_components_pdf_viewer: dynamic(() => import('@gwp-components/pdf-viewer')),
gwp_components_price: dynamic(() => import('@gwp-components/price')),
gwp_components_progress_bar: dynamic(() => import('@gwp-components/progress-bar')),
gwp_components_read_more: dynamic(() => import('@gwp-components/read-more')),
gwp_components_reusable_block: dynamic(() => import('@gwp-components/reusable-block')),
gwp_components_rich_text: dynamic(() => import('@gwp-components/rich-text')),
gwp_components_slot: dynamic(() => import('@gwp-components/slot')),
gwp_components_slot_group: dynamic(() => import('@gwp-components/slot-group')),
gwp_components_stars: dynamic(() => import('@gwp-components/stars')),
gwp_components_sticky_container: dynamic(() => import('@gwp-components/sticky-container')),
gwp_components_tab_item: dynamic(() => import('@gwp-components/tab-item')),
gwp_components_table: dynamic(() => import('@gwp-components/table')),
gwp_components_table_body: dynamic(() => import('@gwp-components/table-body')),
gwp_components_table_header: dynamic(() => import('@gwp-components/table-header')),
gwp_components_table_header_item: dynamic(() => import('@gwp-components/table-header-item')),
gwp_components_table_of_contents: dynamic(() => import('@gwp-components/table-of-contents')),
gwp_components_table_row: dynamic(() => import('@gwp-components/table-row')),
gwp_components_table_row_item: dynamic(() => import('@gwp-components/table-row-item')),
gwp_components_tabs: dynamic(() => import('@gwp-components/tabs')),
gwp_components_text: dynamic(() => import('@gwp-components/text')),
gwp_components_tile: dynamic(() => import('@gwp-components/tile')),
gwp_components_typography: dynamic(() => import('@gwp-components/typography')),
gwp_components_vertical_tab_item: dynamic(() => import('@gwp-components/vertical-tab-item')),
gwp_components_vertical_tabs: dynamic(() => import('@gwp-components/vertical-tabs')),
gwp_components_video: dynamic(() => import('@gwp-components/video')),
gwp_components_youtube: dynamic(() => import('@gwp-components/youtube')),
mds_components_adaptive_table: dynamic(() => import('@mds-components/adaptive-table')),
mds_components_ai_suggestion_deck: dynamic(() => import('@mds-components/ai-suggestion-deck')),
mds_components_animated_prompt_bar: dynamic(() => import('@mds-components/animated-prompt-bar')),
mds_components_animated_video_banner: dynamic(() => import('@mds-components/animated-video-banner')),
mds_components_article_component: dynamic(() => import('@mds-components/article-component')),
mds_components_article_right_rail: dynamic(() => import('@mds-components/article-right-rail')),
mds_components_article_right_rail_item: dynamic(() => import('@mds-components/article-right-rail-item')),
mds_components_article_voting: dynamic(() => import('@mds-components/article-voting')),
mds_components_badge: dynamic(() => import('@mds-components/badge')),
mds_components_bento_box: dynamic(() => import('@mds-components/bento-box')),
mds_components_brightedge: dynamic(() => import('@mds-components/brightedge')),
mds_components_card_grid: dynamic(() => import('@mds-components/card-grid')),
mds_components_checkbox: dynamic(() => import('@mds-components/checkbox')),
mds_components_checkout_widget: dynamic(() => import('@mds-components/checkout-widget')),
mds_components_compare_all_features: dynamic(() => import('@mds-components/compare-all-features')),
mds_components_customer_stories: dynamic(() => import('@mds-components/customer-stories')),
mds_components_customer_stories_customer: dynamic(() => import('@mds-components/customer-stories-customer')),
mds_components_direct_ask_embedded_container: dynamic(() => import('@mds-components/direct-ask-embedded-container')),
mds_components_direct_ask_embedded_form: dynamic(() => import('@mds-components/direct-ask-embedded-form')),
mds_components_direct_ask_modal_v2: dynamic(() => import('@mds-components/direct-ask-modal-v2')),
mds_components_direct_ask_modal_v3: dynamic(() => import('@mds-components/direct-ask-modal-v3')),
mds_components_embedded_sui: dynamic(() => import('@mds-components/embedded-sui')),
mds_components_enterprise_buy_online: dynamic(() => import('@mds-components/enterprise-buy-online')),
mds_components_feature_roller: dynamic(() => import('@mds-components/feature-roller')),
mds_components_federation_consumer: dynamic(() => import('@mds-components/federation-consumer')),
mds_components_feedback_form: dynamic(() => import('@mds-components/feedback-form')),
mds_components_fotf_cas_calc: dynamic(() => import('@mds-components/fotf-cas-calc')),
mds_components_fotf_roi_calc: dynamic(() => import('@mds-components/fotf-roi-calc')),
mds_components_freemium_banner: dynamic(() => import('@mds-components/freemium-banner')),
mds_components_help_search: dynamic(() => import('@mds-components/help-search')),
mds_components_hero_section: dynamic(() => import('@mds-components/hero-section')),
mds_components_homepage_hero: dynamic(() => import('@mds-components/homepage-hero')),
mds_components_horizontal_carousel: dynamic(() => import('@mds-components/horizontal-carousel')),
mds_components_infinite_image_slider: dynamic(() => import('@mds-components/infinite-image-slider')),
mds_components_interactive_product_brochure: dynamic(() => import('@mds-components/interactive-product-brochure')),
mds_components_invoice_generator: dynamic(() => import('@mds-components/invoice-generator')),
mds_components_ipd_add_employee_widget: dynamic(() => import('@mds-components/ipd-add-employee-widget')),
mds_components_ipd_advanced_downgrade_widget: dynamic(() => import('@mds-components/ipd-advanced-downgrade-widget')),
mds_components_ipd_button: dynamic(() => import('@mds-components/ipd-button')),
mds_components_ipd_price_card_widget: dynamic(() => import('@mds-components/ipd-price-card-widget')),
mds_components_ipd_pricing_block: dynamic(() => import('@mds-components/ipd-pricing-block')),
mds_components_ipd_qbl_price_selector: dynamic(() => import('@mds-components/ipd-qbl-price-selector')),
mds_components_ipd_sku_picker_container: dynamic(() => import('@mds-components/ipd-sku-picker-container')),
mds_components_ipd_sku_picker_row: dynamic(() => import('@mds-components/ipd-sku-picker-row')),
mds_components_ipd_widget_consumer: dynamic(() => import('@mds-components/ipd-widget-consumer')),
mds_components_laptop_scroll_animator: dynamic(() => import('@mds-components/laptop-scroll-animator')),
mds_components_lazy_component: dynamic(() => import('@mds-components/lazy-component')),
mds_components_lead_form: dynamic(() => import('@mds-components/lead-form')),
mds_components_legal_disclaimer: dynamic(() => import('@mds-components/legal-disclaimer')),
mds_components_live_person_chat: dynamic(() => import('@mds-components/live-person-chat')),
mds_components_live_person_chat_now: dynamic(() => import('@mds-components/live-person-chat-now')),
mds_components_lottie: dynamic(() => import('@mds-components/lottie')),
mds_components_magic_carpet: dynamic(() => import('@mds-components/magic-carpet')),
mds_components_mc_plan_item: dynamic(() => import('@mds-components/mc-plan-item')),
mds_components_mc_plans_container: dynamic(() => import('@mds-components/mc-plans-container')),
mds_components_mds_global_nav: dynamic(() => import('@mds-components/mds-global-nav')),
mds_components_mobile_sticky_nav: dynamic(() => import('@mds-components/mobile-sticky-nav')),
mds_components_next_best_page: dynamic(() => import('@mds-components/next-best-page')),
mds_components_payments_calculator: dynamic(() => import('@mds-components/payments-calculator')),
mds_components_personalization_config_provider: dynamic(() => import('@mds-components/personalization-config-provider')),
mds_components_personalized_card_carousel: dynamic(() => import('@mds-components/personalized-card-carousel')),
mds_components_personalized_cards: dynamic(() => import('@mds-components/personalized-cards')),
mds_components_personalized_cards_v2: dynamic(() => import('@mds-components/personalized-cards-v2')),
mds_components_personalized_industry: dynamic(() => import('@mds-components/personalized-industry')),
mds_components_plan_card: dynamic(() => import('@mds-components/plan-card')),
mds_components_plan_inclusion: dynamic(() => import('@mds-components/plan-inclusion')),
mds_components_pre_auth_omni_ui: dynamic(() => import('@mds-components/pre-auth-omni-ui')),
mds_components_qb_live_pricing_component: dynamic(() => import('@mds-components/qb-live-pricing-component')),
mds_components_qbl_dynamic_pricing: dynamic(() => import('@mds-components/qbl-dynamic-pricing')),
mds_components_qrc_cc_payoff_calculator: dynamic(() => import('@mds-components/qrc-cc-payoff-calculator')),
mds_components_responsive_ad_display: dynamic(() => import('@mds-components/responsive-ad-display')),
mds_components_rw_on_page_nav: dynamic(() => import('@mds-components/rw-on-page-nav')),
mds_components_rw_on_page_nav_item: dynamic(() => import('@mds-components/rw-on-page-nav-item')),
mds_components_same_route_navigation: dynamic(() => import('@mds-components/same-route-navigation')),
mds_components_search_results: dynamic(() => import('@mds-components/search-results')),
mds_components_section_navigator: dynamic(() => import('@mds-components/section-navigator')),
mds_components_self_id: dynamic(() => import('@mds-components/self-id')),
mds_components_shopping_widget: dynamic(() => import('@mds-components/shopping-widget')),
mds_components_shopping_widget_v2: dynamic(() => import('@mds-components/shopping-widget-v2')),
mds_components_snackable_cards_slider: dynamic(() => import('@mds-components/snackable-cards-slider')),
mds_components_snackable_cards_slider_item: dynamic(() => import('@mds-components/snackable-cards-slider-item')),
mds_components_social_proof: dynamic(() => import('@mds-components/social-proof')),
mds_components_social_proof_capability: dynamic(() => import('@mds-components/social-proof-capability')),
mds_components_social_proof_section: dynamic(() => import('@mds-components/social-proof-section')),
mds_components_support: dynamic(() => import('@mds-components/support')),
mds_components_tabbed_panel: dynamic(() => import('@mds-components/tabbed-panel')),
mds_components_table_cell: dynamic(() => import('@mds-components/table-cell')),
mds_components_table_of_contents: dynamic(() => import('@mds-components/table-of-contents')),
mds_components_table_of_contents_item: dynamic(() => import('@mds-components/table-of-contents-item')),
mds_components_table_row: dynamic(() => import('@mds-components/table-row')),
mds_components_tip_box: dynamic(() => import('@mds-components/tip-box')),
mds_components_vertical_carousel: dynamic(() => import('@mds-components/vertical-carousel')),
mds_components_vertical_carousel_item: dynamic(() => import('@mds-components/vertical-carousel-item')),
mds_components_video_card: dynamic(() => import('@mds-components/video-card')),
mds_components_adaptive_table: dynamic(() => import('@mds-components/adaptive-table')),
mds_components_ai_suggestion_deck: dynamic(() => import('@mds-components/ai-suggestion-deck')),
mds_components_animated_prompt_bar: dynamic(() => import('@mds-components/animated-prompt-bar')),
mds_components_animated_video_banner: dynamic(() => import('@mds-components/animated-video-banner')),
mds_components_article_component: dynamic(() => import('@mds-components/article-component')),
mds_components_article_right_rail: dynamic(() => import('@mds-components/article-right-rail')),
mds_components_article_right_rail_item: dynamic(() => import('@mds-components/article-right-rail-item')),
mds_components_article_voting: dynamic(() => import('@mds-components/article-voting')),
mds_components_badge: dynamic(() => import('@mds-components/badge')),
mds_components_bento_box: dynamic(() => import('@mds-components/bento-box')),
mds_components_brightedge: dynamic(() => import('@mds-components/brightedge')),
mds_components_card_grid: dynamic(() => import('@mds-components/card-grid')),
mds_components_checkbox: dynamic(() => import('@mds-components/checkbox')),
mds_components_checkout_widget: dynamic(() => import('@mds-components/checkout-widget')),
mds_components_compare_all_features: dynamic(() => import('@mds-components/compare-all-features')),
mds_components_customer_stories: dynamic(() => import('@mds-components/customer-stories')),
mds_components_customer_stories_customer: dynamic(() => import('@mds-components/customer-stories-customer')),
mds_components_direct_ask_embedded_container: dynamic(() => import('@mds-components/direct-ask-embedded-container')),
mds_components_direct_ask_embedded_form: dynamic(() => import('@mds-components/direct-ask-embedded-form')),
mds_components_direct_ask_modal_v2: dynamic(() => import('@mds-components/direct-ask-modal-v2')),
mds_components_direct_ask_modal_v3: dynamic(() => import('@mds-components/direct-ask-modal-v3')),
mds_components_embedded_sui: dynamic(() => import('@mds-components/embedded-sui')),
mds_components_enterprise_buy_online: dynamic(() => import('@mds-components/enterprise-buy-online')),
mds_components_feature_roller: dynamic(() => import('@mds-components/feature-roller')),
mds_components_federation_consumer: dynamic(() => import('@mds-components/federation-consumer')),
mds_components_feedback_form: dynamic(() => import('@mds-components/feedback-form')),
mds_components_fotf_cas_calc: dynamic(() => import('@mds-components/fotf-cas-calc')),
mds_components_fotf_roi_calc: dynamic(() => import('@mds-components/fotf-roi-calc')),
mds_components_freemium_banner: dynamic(() => import('@mds-components/freemium-banner')),
mds_components_help_search: dynamic(() => import('@mds-components/help-search')),
mds_components_hero_section: dynamic(() => import('@mds-components/hero-section')),
mds_components_homepage_hero: dynamic(() => import('@mds-components/homepage-hero')),
mds_components_horizontal_carousel: dynamic(() => import('@mds-components/horizontal-carousel')),
mds_components_infinite_image_slider: dynamic(() => import('@mds-components/infinite-image-slider')),
mds_components_interactive_product_brochure: dynamic(() => import('@mds-components/interactive-product-brochure')),
mds_components_invoice_generator: dynamic(() => import('@mds-components/invoice-generator')),
mds_components_ipd_add_employee_widget: dynamic(() => import('@mds-components/ipd-add-employee-widget')),
mds_components_ipd_advanced_downgrade_widget: dynamic(() => import('@mds-components/ipd-advanced-downgrade-widget')),
mds_components_ipd_button: dynamic(() => import('@mds-components/ipd-button')),
mds_components_ipd_price_card_widget: dynamic(() => import('@mds-components/ipd-price-card-widget')),
mds_components_ipd_pricing_block: dynamic(() => import('@mds-components/ipd-pricing-block')),
mds_components_ipd_qbl_price_selector: dynamic(() => import('@mds-components/ipd-qbl-price-selector')),
mds_components_ipd_sku_picker_container: dynamic(() => import('@mds-components/ipd-sku-picker-container')),
mds_components_ipd_sku_picker_row: dynamic(() => import('@mds-components/ipd-sku-picker-row')),
mds_components_ipd_widget_consumer: dynamic(() => import('@mds-components/ipd-widget-consumer')),
mds_components_laptop_scroll_animator: dynamic(() => import('@mds-components/laptop-scroll-animator')),
mds_components_lazy_component: dynamic(() => import('@mds-components/lazy-component')),
mds_components_lead_form: dynamic(() => import('@mds-components/lead-form')),
mds_components_legal_disclaimer: dynamic(() => import('@mds-components/legal-disclaimer')),
mds_components_live_person_chat: dynamic(() => import('@mds-components/live-person-chat')),
mds_components_live_person_chat_now: dynamic(() => import('@mds-components/live-person-chat-now')),
mds_components_lottie: dynamic(() => import('@mds-components/lottie')),
mds_components_magic_carpet: dynamic(() => import('@mds-components/magic-carpet')),
mds_components_mc_plan_item: dynamic(() => import('@mds-components/mc-plan-item')),
mds_components_mc_plans_container: dynamic(() => import('@mds-components/mc-plans-container')),
mds_components_mds_global_nav: dynamic(() => import('@mds-components/mds-global-nav')),
mds_components_mobile_sticky_nav: dynamic(() => import('@mds-components/mobile-sticky-nav')),
mds_components_next_best_page: dynamic(() => import('@mds-components/next-best-page')),
mds_components_payments_calculator: dynamic(() => import('@mds-components/payments-calculator')),
mds_components_personalization_config_provider: dynamic(() => import('@mds-components/personalization-config-provider')),
mds_components_personalized_card_carousel: dynamic(() => import('@mds-components/personalized-card-carousel')),
mds_components_personalized_cards: dynamic(() => import('@mds-components/personalized-cards')),
mds_components_personalized_cards_v2: dynamic(() => import('@mds-components/personalized-cards-v2')),
mds_components_personalized_industry: dynamic(() => import('@mds-components/personalized-industry')),
mds_components_plan_card: dynamic(() => import('@mds-components/plan-card')),
mds_components_plan_inclusion: dynamic(() => import('@mds-components/plan-inclusion')),
mds_components_pre_auth_omni_ui: dynamic(() => import('@mds-components/pre-auth-omni-ui')),
mds_components_qb_live_pricing_component: dynamic(() => import('@mds-components/qb-live-pricing-component')),
mds_components_qbl_dynamic_pricing: dynamic(() => import('@mds-components/qbl-dynamic-pricing')),
mds_components_qrc_cc_payoff_calculator: dynamic(() => import('@mds-components/qrc-cc-payoff-calculator')),
mds_components_responsive_ad_display: dynamic(() => import('@mds-components/responsive-ad-display')),
mds_components_rw_on_page_nav: dynamic(() => import('@mds-components/rw-on-page-nav')),
mds_components_rw_on_page_nav_item: dynamic(() => import('@mds-components/rw-on-page-nav-item')),
mds_components_same_route_navigation: dynamic(() => import('@mds-components/same-route-navigation')),
mds_components_search_results: dynamic(() => import('@mds-components/search-results')),
mds_components_section_navigator: dynamic(() => import('@mds-components/section-navigator')),
mds_components_self_id: dynamic(() => import('@mds-components/self-id')),
mds_components_shopping_widget: dynamic(() => import('@mds-components/shopping-widget')),
mds_components_shopping_widget_v2: dynamic(() => import('@mds-components/shopping-widget-v2')),
mds_components_snackable_cards_slider: dynamic(() => import('@mds-components/snackable-cards-slider')),
mds_components_snackable_cards_slider_item: dynamic(() => import('@mds-components/snackable-cards-slider-item')),
mds_components_social_proof: dynamic(() => import('@mds-components/social-proof')),
mds_components_social_proof_capability: dynamic(() => import('@mds-components/social-proof-capability')),
mds_components_social_proof_section: dynamic(() => import('@mds-components/social-proof-section')),
mds_components_support: dynamic(() => import('@mds-components/support')),
mds_components_tabbed_panel: dynamic(() => import('@mds-components/tabbed-panel')),
mds_components_table_cell: dynamic(() => import('@mds-components/table-cell')),
mds_components_table_of_contents: dynamic(() => import('@mds-components/table-of-contents')),
mds_components_table_of_contents_item: dynamic(() => import('@mds-components/table-of-contents-item')),
mds_components_table_row: dynamic(() => import('@mds-components/table-row')),
mds_components_tip_box: dynamic(() => import('@mds-components/tip-box')),
mds_components_vertical_carousel: dynamic(() => import('@mds-components/vertical-carousel')),
mds_components_vertical_carousel_item: dynamic(() => import('@mds-components/vertical-carousel-item')),
mds_components_video_card: dynamic(() => import('@mds-components/video-card')),
mds_apps: dynamic(() => import('@mds/apps')),
mds_authentication: dynamic(() => import('@mds/authentication')),
mds_author_articles_container: dynamic(() => import('@mds/author-articles-container')),
mds_author_bio: dynamic(() => import('@mds/author-bio')),
mds_author_hero: dynamic(() => import('@mds/author-hero')),
mds_awards_block: dynamic(() => import('@mds/awards-block')),
mds_awards_block_item: dynamic(() => import('@mds/awards-block-item')),
mds_background_video: dynamic(() => import('@mds/background-video')),
mds_breadcrumbs: dynamic(() => import('@mds/breadcrumbs')),
mds_bullets_controls: dynamic(() => import('@mds/bullets-controls')),
mds_careers_header: dynamic(() => import('@mds/careers-header')),
mds_careers_header_item_full_bleed: dynamic(() => import('@mds/careers-header-item-full-bleed')),
mds_checkbox_container: dynamic(() => import('@mds/checkbox-container')),
mds_comp_chart: dynamic(() => import('@mds/comp-chart')),
mds_comp_chart_group: dynamic(() => import('@mds/comp-chart-group')),
mds_contact_us_dropdown: dynamic(() => import('@mds/contact-us-dropdown')),
mds_content_replacement_item: dynamic(() => import('@mds/content-replacement-item')),
mds_content_switcher: dynamic(() => import('@mds/content-switcher')),
mds_content_switcher_item: dynamic(() => import('@mds/content-switcher-item')),
mds_custom_phone: dynamic(() => import('@mds/custom-phone')),
mds_drawer_component: dynamic(() => import('@mds/drawer-component')),
mds_dropdown_item: dynamic(() => import('@mds/dropdown-item')),
mds_dynamic_category_container: dynamic(() => import('@mds/dynamic-category-container')),
mds_dynamic_text_block: dynamic(() => import('@mds/dynamic-text-block')),
mds_employee_stories: dynamic(() => import('@mds/employee-stories')),
mds_employee_stories_controls: dynamic(() => import('@mds/employee-stories-controls')),
mds_employee_stories_item: dynamic(() => import('@mds/employee-stories-item')),
mds_featured_media_block: dynamic(() => import('@mds/featured-media-block')),
mds_featured_media_block_item: dynamic(() => import('@mds/featured-media-block-item')),
mds_filter_bar: dynamic(() => import('@mds/filter-bar')),
mds_fitted_heading: dynamic(() => import('@mds/fitted-heading')),
mds_footer_app_icon: dynamic(() => import('@mds/footer-app-icon')),
mds_form: dynamic(() => import('@mds/form')),
mds_form_group: dynamic(() => import('@mds/form-group')),
mds_form_item: dynamic(() => import('@mds/form-item')),
mds_fotf_hero: dynamic(() => import('@mds/fotf-hero')),
mds_fragment: dynamic(() => import('@mds/fragment')),
mds_frame: dynamic(() => import('@mds/frame')),
mds_general_content: dynamic(() => import('@mds/general-content')),
mds_generic_form: dynamic(() => import('@mds/generic-form')),
mds_generic_form_file_upload: dynamic(() => import('@mds/generic-form-file-upload')),
mds_generic_form_hidden_field: dynamic(() => import('@mds/generic-form-hidden-field')),
mds_grid: dynamic(() => import('@mds/grid')),
mds_header_with_number: dynamic(() => import('@mds/header-with-number')),
mds_home_page_hero_ca: dynamic(() => import('@mds/home-page-hero-ca')),
mds_how_it_works: dynamic(() => import('@mds/how-it-works')),
mds_how_it_works_item: dynamic(() => import('@mds/how-it-works-item')),
mds_icom_cards: dynamic(() => import('@mds/icom-cards')),
mds_icom_cards_item: dynamic(() => import('@mds/icom-cards-item')),
mds_icom_hero: dynamic(() => import('@mds/icom-hero')),
mds_icom_search_field: dynamic(() => import('@mds/icom-search-field')),
mds_icom_tabs_grid: dynamic(() => import('@mds/icom-tabs-grid')),
mds_icom_tabs_grid_item: dynamic(() => import('@mds/icom-tabs-grid-item')),
mds_image_button: dynamic(() => import('@mds/image-button')),
mds_input: dynamic(() => import('@mds/input')),
mds_ipd_bundle_price_card: dynamic(() => import('@mds/ipd-bundle-price-card')),
mds_ipd_chili_piper: dynamic(() => import('@mds/ipd-chili-piper')),
mds_ipd_feature_item: dynamic(() => import('@mds/ipd-feature-item')),
mds_ipd_feature_list: dynamic(() => import('@mds/ipd-feature-list')),
mds_ipd_payroll_sign_up: dynamic(() => import('@mds/ipd-payroll-sign-up')),
mds_ipd_price_card: dynamic(() => import('@mds/ipd-price-card')),
mds_ipd_price_card_container: dynamic(() => import('@mds/ipd-price-card-container')),
mds_ipd_qb_live_consultation_scheduler: dynamic(() => import('@mds/ipd-qb-live-consultation-scheduler')),
mds_ipd_tiles: dynamic(() => import('@mds/ipd-tiles')),
mds_ipd_tiles_layout: dynamic(() => import('@mds/ipd-tiles-layout')),
mds_ipd_tsm: dynamic(() => import('@mds/ipd-tsm')),
mds_key_job_openings: dynamic(() => import('@mds/key-job-openings')),
mds_key_job_openings_item: dynamic(() => import('@mds/key-job-openings-item')),
mds_linked_in_auto_fill: dynamic(() => import('@mds/linked-in-auto-fill')),
mds_lottie: dynamic(() => import('@mds/lottie')),
mds_magic_carpet: dynamic(() => import('@mds/magic-carpet')),
mds_map: dynamic(() => import('@mds/map')),
mds_map_item: dynamic(() => import('@mds/map-item')),
mds_maps: dynamic(() => import('@mds/maps')),
mds_maps_item: dynamic(() => import('@mds/maps-item')),
mds_market_personalization_popup: dynamic(() => import('@mds/market-personalization-popup')),
mds_media_gallery: dynamic(() => import('@mds/media-gallery')),
mds_multi_select_dropdown: dynamic(() => import('@mds/multi-select-dropdown')),
mds_multi_select_dropdown_item: dynamic(() => import('@mds/multi-select-dropdown-item')),
mds_nav_card: dynamic(() => import('@mds/nav-card')),
mds_non_auth_product_finder: dynamic(() => import('@mds/non-auth-product-finder')),
mds_non_auth_product_finder_card: dynamic(() => import('@mds/non-auth-product-finder-card')),
mds_non_auth_product_finder_card_item: dynamic(() => import('@mds/non-auth-product-finder-card-item')),
mds_oisp_loadmore: dynamic(() => import('@mds/oisp-loadmore')),
mds_pcg_hero: dynamic(() => import('@mds/pcg-hero')),
mds_pcg_hero_frame: dynamic(() => import('@mds/pcg-hero-frame')),
mds_percentage_block: dynamic(() => import('@mds/percentage-block')),
mds_phone_flyout_ca: dynamic(() => import('@mds/phone-flyout-ca')),
mds_pill_toggle_switch: dynamic(() => import('@mds/pill-toggle-switch')),
mds_pricing_comparison_chart: dynamic(() => import('@mds/pricing-comparison-chart')),
mds_pricing_hero_ca: dynamic(() => import('@mds/pricing-hero-ca')),
mds_product_banner: dynamic(() => import('@mds/product-banner')),
mds_product_finder_question: dynamic(() => import('@mds/product-finder-question')),
mds_product_finder_question_card: dynamic(() => import('@mds/product-finder-question-card')),
mds_product_finder_question_card_item: dynamic(() => import('@mds/product-finder-question-card-item')),
mds_product_finder_question_tooltip: dynamic(() => import('@mds/product-finder-question-tooltip')),
mds_product_timeline: dynamic(() => import('@mds/product-timeline')),
mds_product_timeline_item: dynamic(() => import('@mds/product-timeline-item')),
mds_propensity: dynamic(() => import('@mds/propensity')),
mds_qb_support_prompt: dynamic(() => import('@mds/qb-support-prompt')),
mds_qrc_article_hero: dynamic(() => import('@mds/qrc-article-hero')),
mds_qrc_content_card: dynamic(() => import('@mds/qrc-content-card')),
mds_qrc_content_card_grid: dynamic(() => import('@mds/qrc-content-card-grid')),
mds_qrc_image_gallery: dynamic(() => import('@mds/qrc-image-gallery')),
mds_qrc_lead_gen_float_bar: dynamic(() => import('@mds/qrc-lead-gen-float-bar')),
mds_qrc_mega_nav_section: dynamic(() => import('@mds/qrc-mega-nav-section')),
mds_qrc_tags: dynamic(() => import('@mds/qrc-tags')),
mds_qrc_tools: dynamic(() => import('@mds/qrc-tools')),
mds_quick_links: dynamic(() => import('@mds/quick-links')),
mds_quote: dynamic(() => import('@mds/quote')),
mds_related_articles: dynamic(() => import('@mds/related-articles')),
mds_reusable_blocks: dynamic(() => import('@mds/reusable-blocks')),
mds_review_block: dynamic(() => import('@mds/review-block')),
mds_review_stars: dynamic(() => import('@mds/review-stars')),
mds_rw_accordion: dynamic(() => import('@mds/rw-accordion')),
mds_rw_banner: dynamic(() => import('@mds/rw-banner')),
mds_rw_card: dynamic(() => import('@mds/rw-card')),
mds_rw_cards_container: dynamic(() => import('@mds/rw-cards-container')),
mds_rw_carousel: dynamic(() => import('@mds/rw-carousel')),
mds_rw_cart: dynamic(() => import('@mds/rw-cart')),
mds_rw_cart_row: dynamic(() => import('@mds/rw-cart-row')),
mds_rw_clickable_tooltip: dynamic(() => import('@mds/rw-clickable-tooltip')),
mds_rw_disclaimer: dynamic(() => import('@mds/rw-disclaimer')),
mds_rw_disclaimer_group: dynamic(() => import('@mds/rw-disclaimer-group')),
mds_rw_disclaimer_item: dynamic(() => import('@mds/rw-disclaimer-item')),
mds_rw_ecosystem_module: dynamic(() => import('@mds/rw-ecosystem-module')),
mds_rw_feature_cell: dynamic(() => import('@mds/rw-feature-cell')),
mds_rw_feature_list: dynamic(() => import('@mds/rw-feature-list')),
mds_rw_feature_section: dynamic(() => import('@mds/rw-feature-section')),
mds_rw_features_navigation: dynamic(() => import('@mds/rw-features-navigation')),
mds_rw_features_navigation_category: dynamic(() => import('@mds/rw-features-navigation-category')),
mds_rw_features_navigation_category_item: dynamic(() => import('@mds/rw-features-navigation-category-item')),
mds_rw_global_nav: dynamic(() => import('@mds/rw-global-nav')),
mds_rw_hero: dynamic(() => import('@mds/rw-hero')),
mds_rw_menu_item: dynamic(() => import('@mds/rw-menu-item')),
mds_rw_multi_image_container: dynamic(() => import('@mds/rw-multi-image-container')),
mds_rw_nav_menu: dynamic(() => import('@mds/rw-nav-menu')),
mds_rw_nav_menu_item: dynamic(() => import('@mds/rw-nav-menu-item')),
mds_rw_nav_menu_list: dynamic(() => import('@mds/rw-nav-menu-list')),
mds_rw_plan_detail_cards: dynamic(() => import('@mds/rw-plan-detail-cards')),
mds_rw_plan_inclusion_cards_container: dynamic(() => import('@mds/rw-plan-inclusion-cards-container')),
mds_rw_price_card: dynamic(() => import('@mds/rw-price-card')),
mds_rw_price_card_container: dynamic(() => import('@mds/rw-price-card-container')),
mds_rw_price_card_item: dynamic(() => import('@mds/rw-price-card-item')),
mds_rw_product_finder_header: dynamic(() => import('@mds/rw-product-finder-header')),
mds_rw_secondary_nav: dynamic(() => import('@mds/rw-secondary-nav')),
mds_rw_secondary_nav_link: dynamic(() => import('@mds/rw-secondary-nav-link')),
mds_rw_share_url: dynamic(() => import('@mds/rw-share-url')),
mds_rw_snowglobe_quiz: dynamic(() => import('@mds/rw-snowglobe-quiz')),
mds_rw_spinner: dynamic(() => import('@mds/rw-spinner')),
mds_rw_standalone_price_card: dynamic(() => import('@mds/rw-standalone-price-card')),
mds_rw_step_flow: dynamic(() => import('@mds/rw-step-flow')),
mds_rw_step_flow_item: dynamic(() => import('@mds/rw-step-flow-item')),
mds_rw_step_progress: dynamic(() => import('@mds/rw-step-progress')),
mds_rw_tab_item: dynamic(() => import('@mds/rw-tab-item')),
mds_rw_tabs: dynamic(() => import('@mds/rw-tabs')),
mds_rw_testimonial: dynamic(() => import('@mds/rw-testimonial')),
mds_rw_testimonial_item: dynamic(() => import('@mds/rw-testimonial-item')),
mds_rw_text_grid: dynamic(() => import('@mds/rw-text-grid')),
mds_rw_vertical_carousel: dynamic(() => import('@mds/rw-vertical-carousel')),
mds_rw_vertical_carousel_item: dynamic(() => import('@mds/rw-vertical-carousel-item')),
mds_rw_vertical_price_card: dynamic(() => import('@mds/rw-vertical-price-card')),
mds_rw_vertical_scroll_feature: dynamic(() => import('@mds/rw-vertical-scroll-feature')),
mds_rw_vertical_scroll_feature_item: dynamic(() => import('@mds/rw-vertical-scroll-feature-item')),
mds_rw2_hero: dynamic(() => import('@mds/rw2-hero')),
mds_rw3_hero: dynamic(() => import('@mds/rw3-hero')),
mds_search_bar: dynamic(() => import('@mds/search-bar')),
mds_search_template: dynamic(() => import('@mds/search-template')),
mds_sign_in_menu: dynamic(() => import('@mds/sign-in-menu')),
mds_site_search: dynamic(() => import('@mds/site-search')),
mds_slider_controls: dynamic(() => import('@mds/slider-controls')),
mds_small_card: dynamic(() => import('@mds/small-card')),
mds_social_links: dynamic(() => import('@mds/social-links')),
mds_social_media: dynamic(() => import('@mds/social-media')),
mds_stats_block: dynamic(() => import('@mds/stats-block')),
mds_stats_block_item: dynamic(() => import('@mds/stats-block-item')),
mds_support: dynamic(() => import('@mds/support')),
mds_talk_to_sales: dynamic(() => import('@mds/talk-to-sales')),
mds_text_area: dynamic(() => import('@mds/text-area')),
mds_toggle_switch: dynamic(() => import('@mds/toggle-switch')),
mds_video_iframe: dynamic(() => import('@mds/video-iframe')),
row_components_pricing_embedded_sui: dynamic(() => import('@row-components/pricing-embedded-sui')),
row_components_row_pricing: dynamic(() => import('@row-components/row-pricing')),
row_components_row_rw_chart: dynamic(() => import('@row-components/row-rw-chart')),
row_components_row_rw_features_carousel: dynamic(() => import('@row-components/row-rw-features-carousel')),
row_components_row_rw_features_section: dynamic(() => import('@row-components/row-rw-features-section')),
row_components_row_rw_sub_banner: dynamic(() => import('@row-components/row-rw-sub-banner')),
uk_components_ivan_test: dynamic(() => import('@uk-components/ivan-test')),
uk_components_uk_promo: dynamic(() => import('@uk-components/uk-promo')),
uxbrand_components_color_widget: dynamic(() => import('@uxbrand-components/color-widget')),
uxbrand_components_illustration_widget: dynamic(() => import('@uxbrand-components/illustration-widget')),
uxbrand_components_logo_widget: dynamic(() => import('@uxbrand-components/logo-widget')),
uxbrand_components_photography_widget: dynamic(() => import('@uxbrand-components/photography-widget')),
uxbrand_components_typography_widget: dynamic(() => import('@uxbrand-components/typography-widget')),
uxbrand_components_voice_tone_widget: dynamic(() => import('@uxbrand-components/voice-tone-widget')),

au_components_au_pricing: dynamic(() => import("@au-components/au-pricing"),
{ ssr: false }), mds_components_scroll_animator: dynamic(() => import("@mds-components/scroll-animator"),
{ ssr: false }),helix_common_pzn_container_block: dynamic(() =>
import('@gwp/oicms-rendering-utils').then((mod) =>
mod.components.Pzn.pznContainer)), helix_common_section: dynamic(() =>
import('@gwp/oicms-rendering-utils').then((mod) =>
mod.components.FreeSection.freeSectionContainer)),
helix_display_title: dynamic(() => Promise.resolve(() => React.createElement(React.Fragment))),
helix_author_notes_block: dynamic(() => Promise.resolve(() => React.createElement(React.Fragment)))
} /** * Method to return
dynamic import for a component * @param {String} blockName */ export const
getComponent = blockName => { return componentMap[blockName.replace(/\/|-/gi,
'_')] }